import { render, staticRenderFns } from "./Pop-up.vue?vue&type=template&id=53a5332a&scoped=true"
import script from "./Pop-up.vue?vue&type=script&lang=js"
export * from "./Pop-up.vue?vue&type=script&lang=js"
import style0 from "./Pop-up.vue?vue&type=style&index=0&id=53a5332a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5332a",
  null
  
)

export default component.exports